import { useState, useMemo } from 'react';

// Custom hook for filtering profiles by category
export const useFilter = (profiles) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredProfiles = useMemo(() => {
    if (selectedCategory === 'all') {
      return profiles;
    }
    return profiles.filter(profile => profile.category === selectedCategory);
  }, [profiles, selectedCategory]);

  const filterByCategory = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  return {
    filteredProfiles,
    selectedCategory,
    filterByCategory
  };
};
